import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconUnlink(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.18.387a1 1 0 0 0-.703 1.227l1.051 3.86a1 1 0 0 0 1.93-.526l-1.051-3.86a1 1 0 0 0-1.228-.7zm7.785 17.876a1 1 0 0 0-.702 1.227l1.051 3.86a1 1 0 1 0 1.93-.526l-1.052-3.86a1 1 0 0 0-1.227-.701zM1.895 5.905a1 1 0 1 1 .992-1.737L6.36 6.155a1 1 0 0 1-.993 1.736L1.894 5.905zm15.465 10.57a1 1 0 0 0 .371 1.364l3.474 1.987a1 1 0 1 0 .993-1.736l-3.474-1.987a1 1 0 0 0-1.364.372zm2.403-6.696-2.988 2.988c-1 1 .225 2.233 1.414 1.414l3-3a6 6 0 0 0-8.472-8.496l-1.73 1.72a1 1 0 0 0 1.41 1.418l1.72-1.71a3.997 3.997 0 0 1 5.597.059 4 4 0 0 1 .049 5.607zM5.695 9.687C6.5 9 7.93 10.28 7.109 11.1l-2.988 2.987a4 4 0 0 0 .049 5.607c1.543 1.543 4.038 1.565 5.595.061l1.71-1.71a1 1 0 1 1 1.414 1.415l-1.722 1.722a6 6 0 0 1-8.472-8.496l3-3z"
  }));
}
IconUnlink.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconUnlink.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconUnlink as default };
